(() => {
  const init = (scope = document) => {
    scope.querySelectorAll('[data-mm-tabs]:not([data-mm-ready])').forEach(group => {
      const tabs = [...group.querySelectorAll('[data-mm-tab]')];
      const panels = [...group.querySelectorAll('[data-mm-panel]')];
      const base = group.closest('[id]')?.id || 'mm-products';
      const select = tab => {
        tabs.forEach(t => { const active = t === tab; t.setAttribute('aria-selected', String(active)); t.tabIndex = active ? 0 : -1; });
        panels.forEach(p => { p.hidden = p.dataset.mmPanel !== tab.dataset.mmTab; });
      };
      group.querySelector('.mm-tablist').setAttribute('role', 'tablist');
      tabs.forEach((tab, i) => {
        const name = tab.dataset.mmTab;
        tab.setAttribute('role', 'tab'); tab.id = `${base}-tab-${name}`;
        tab.setAttribute('aria-controls', `${base}-panel-${name}`);
        tab.addEventListener('click', () => select(tab));
        tab.addEventListener('keydown', event => {
          let index;
          if (event.key === 'ArrowRight') index = (i + 1) % tabs.length;
          if (event.key === 'ArrowLeft') index = (i + tabs.length - 1) % tabs.length;
          if (event.key === 'Home') index = 0;
          if (event.key === 'End') index = tabs.length - 1;
          if (index !== undefined) { event.preventDefault(); select(tabs[index]); tabs[index].focus(); }
        });
      });
      panels.forEach(p => { p.id = `${base}-panel-${p.dataset.mmPanel}`; p.setAttribute('role', 'tabpanel'); p.setAttribute('aria-labelledby', `${base}-tab-${p.dataset.mmPanel}`); });
      select(tabs[0]); group.dataset.mmReady = 'true';
    });
    scope.querySelectorAll('.mm-navigation,.mm-search').forEach(detail => {
      if (detail.dataset.mmReady) return;
      detail.dataset.mmReady = 'true';
      const summary = detail.querySelector('summary');
      const close = () => { detail.open = false; summary?.focus(); };
      detail.querySelector('[data-mm-close-menu]')?.addEventListener('click', close);
      detail.addEventListener('keydown', event => { if (event.key === 'Escape') { event.preventDefault(); close(); } });
      detail.addEventListener('toggle', () => {
        if (!detail.open) return;
        document.querySelectorAll('.mm-navigation[open],.mm-search[open]').forEach(other => { if (other !== detail) other.open = false; });
      });
      document.addEventListener('click', event => { if (detail.open && !detail.contains(event.target)) detail.open = false; });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
